import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getBreachCategoryList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_CATEGORIES}?${stringifyParams(queryParams)}`
	);
};

export const getBreachCategoryListQuery = params => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_CATEGORIES}?${stringifyParams(params)}`
	);
};

export const getBreachCategoryById = id => {
	return apiClient.get(`${INSPECTION_BASE}${url.GET_BREACH_CATEGORY}${id}`);
};

export const addNewBreachCategoryApi = breachCategory => {
	return apiClient.create(
		`${INSPECTION_BASE}${url.POST_BREACH_CATEGORY}`,
		breachCategory
	);
};

export const updateBreachCategoryApi = breachCategory => {
	return apiClient.put(
		`${INSPECTION_BASE}${url.PUT_BREACH_CATEGORY}${breachCategory._id}`,
		breachCategory
	);
};

export const deleteBreachCategoryApi = id => {
	return apiClient.delete(`${INSPECTION_BASE}${url.DELETE_BREACH_CATEGORY}${id}`);
};

export const checkBreachCategoryExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${INSPECTION_BASE}${url.CHECK_BREACH_CATEGORY_EXISTS}?${stringifyParams(
				queryParams
			)}`
		)
		.then(response => ({ exists: response && response.length > 0 }))
		.catch(() => ({ exists: false }));
};
